import { CareerData } from '../dto/EntityRepository';
import { UpdateCareerBulkReq } from '../dto/ReqDtoRepository';
import { toUpdateCareerBulkItemReq } from './normalizeCareer';

export const toUpdateCareerBulkReq = (
  careerList: CareerData[],
): UpdateCareerBulkReq | null => {
  const changedCareers = careerList
    .filter((career) => career.hasChanged)
    .map(toUpdateCareerBulkItemReq);
  if (changedCareers.length === 0) return null;
  return { careerList: changedCareers };
};
